var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',{attrs:{"disabled":_vm.isStart}},[_c('span',[_vm._v(_vm._s(_vm.isStart ? _vm.timed + "S" : _vm.title))])])
}
var staticRenderFns = []

export { render, staticRenderFns }